import { render, staticRenderFns } from "./del.vue?vue&type=template&id=04b8c3b8&scoped=true&"
import script from "./del.vue?vue&type=script&lang=js&"
export * from "./del.vue?vue&type=script&lang=js&"
import style0 from "./del.vue?vue&type=style&index=0&id=04b8c3b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8c3b8",
  null
  
)

export default component.exports